import { render, staticRenderFns } from "./FactoryInvoiceViewPage.vue?vue&type=template&id=8bee6728&scoped=true&"
import script from "./FactoryInvoiceViewPage.vue?vue&type=script&lang=ts&"
export * from "./FactoryInvoiceViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryInvoiceViewPage.vue?vue&type=style&index=0&id=8bee6728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bee6728",
  null
  
)

export default component.exports